export const toLocalMonthDate = (dateStr: string): string => {
  const date = new Date(dateStr)
  return new Intl.DateTimeFormat(undefined, {
    month: 'long',
    day: 'numeric',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }).format(date)
}
